import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import PhraseListTable from './Componate/PhraseListTable'
import CreatePhrese from '../../Phrese/PhreseList/Componate/CreatePhrese'
import { CanAccessThisPage, useRoleVerify } from 'Common/RoleVerify';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const LanguageEdit = () => {
    CanAccessThisPage(["can_edit"]);
    const [refresh, setRefresh] = useState(false);
    const location = useLocation();
    // Extract parent page from URL: /langugel-list/language-edit/english -> langugel-list
    const parentpage = location.pathname.replace('/', '').split('/')[0] || "";
    const canCreate = useRoleVerify(parentpage, ["can_create"]);

    return (
        <>
            {canCreate &&
                <PageBody
                    card={true}
                    headerchildren={<HeadingOne>Add Phrase</HeadingOne>}
                >
                    <CreatePhrese setRefresh={setRefresh} canCreate={canCreate} />
                </PageBody>
            }
            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
                <div className="row g-3">
                    <div className="col-sm-12">
                        <h4 className="mb-0">Update Language Phrases</h4>
                    </div>
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <PhraseListTable refresh={refresh} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default LanguageEdit



